import api from './authService';

export const superAdminAuthService = {
  login: async (mobile: string, password: string) => {
    const response = await api.post('/super-admin/login', { mobile, password });
    return response.data;
  },
};

export const tenantService = {
  getAll: (params?: { status?: string; search?: string; page?: number; limit?: number }) => {
    let url = '/super-admin/tenants?';
    if (params?.status) url += `status=${params.status}&`;
    if (params?.search) url += `search=${encodeURIComponent(params.search)}&`;
    if (params?.page) url += `page=${params.page}&`;
    if (params?.limit) url += `limit=${params.limit}`;
    return api.get(url);
  },
  
  getById: (id: string) => api.get(`/super-admin/tenants/${id}`),
  
  create: (data: {
    tenantName: string;
    tenantCode: string;
    description?: string;
    address?: string;
    contactEmail?: string;
    contactPhone?: string;
    adminName: string;
    adminMobile: string;
    adminPassword: string;
    adminEmail?: string;
    plan?: string;
    maxShops?: number;
    maxStaff?: number;
  }) => api.post('/super-admin/tenants', data),
  
  update: (id: string, data: any) => api.put(`/super-admin/tenants/${id}`, data),
  
  delete: (id: string) => api.delete(`/super-admin/tenants/${id}`),
  
  addAdmin: (tenantId: string, data: {
    name: string;
    mobile: string;
    password: string;
    email?: string;
  }) => api.post(`/super-admin/tenants/${tenantId}/admins`, data),
};

export const superAdminDashboardService = {
  getStats: () => api.get('/super-admin/dashboard'),
};

export const superAdminAccountService = {
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post('/super-admin/change-password', { currentPassword, newPassword }),
};
